import { instance, next } from "./base";

export const getShippingMetrics = async () => {
  const { data } = await instance()
    .get("/api/v1/admin/shipping/metrics")
    .catch((e) => next(e));
  return data?.data;
};

export const getShippingRecords = async () => {
  const { data } = await instance()
    .get("/api/v1/admin/shipping")
    .catch((e) => next(e));
  return data?.data;
};

export const getDropoffRecords = async () => {
  const { data } = await instance()
    .get("/api/v1/admin/drop-offs")
    .catch((e) => next(e));
  return data?.data;
};

export const getDropoffDetail = async (id) => {
  const { data } = await instance()
    .get(`/api/v1/admin/drop-offs/${id}`)
    .catch((e) => next(e));

  return data?.data;
};

export const updateDropoff = async (values) => {
  const id = values.id;
  delete values.id;

  const { data } = await instance()
    .patch(`/api/v1/admin/drop-offs/${id}`, values)
    .catch((e) => next(e));
    
  return data?.data;
};


export const getShippingDetails = async (id) => {
  const { data } = await instance()
    .get(`/api/v1/admin/shipping/${id}`)
    .catch((e) => next(e));
  return data?.data;
};

export const updateShippingDetail = async (values) => {
  const id = values.id;
  delete values.id;
  const { data } = await instance()
    .patch(`/api/v1/admin/shipping/${id}`, values)
    .catch((e) => next(e));
  return data?.data;
};

export const getShippingAddress = async () => {
  const { data } = await instance()
    .get("/api/v1/admin/shipping/addresses")
    .catch((e) => next(e));
  return data?.data;
};

export const addShippingAddress = async (values) => {
  const { data } = await instance()
    .post("/api/v1/admin/shipping/addresses", values)
    .catch((e) => next(e));
  return data?.data;
};

export const updateShippingAddress = async (values) => {
  const id = values.id;
  delete values.id;
  const { data } = await instance()
    .patch(`/api/v1/admin/shipping/addresses/${id}`, values)
    .catch((e) => next(e));
  return data?.data;
};
